import React from 'react';
import { Field, ErrorMessage } from 'formik';
import TextError from '../common/TextError';

const Textarea: React.FC<any> = (props) => {
  const { label, name, type, ...rest } = props;
  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <Field
        className="form-control"
        name={name}
        id={name}
        as={type}
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...rest}
      />
      <ErrorMessage name={name} component={TextError} />
    </div>
  );
};

export default Textarea;
